import script from "./HelpDialogWorkflowCards.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpDialogWorkflowCards.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__